

/* eslint-disable */
import React, { useState } from 'react';
import { Button } from 'src/components/ui/button';
import { ActiveView } from '../tabs/geo-mapper.tab';
import { Download } from 'lucide-react';
import { Input } from 'src/components/ui/input';

interface MenuBarProps {
  className?: string;
  selectedClassName?: string;
  onViewChange: (view: ActiveView) => void;
  activeView: ActiveView;
  searchText: string;
  onSearchChange: (text: string) => void;
  isFiltered: boolean;
  resultCount: number;
  totalCount: number;
}

const GeoMapperMenuBar: React.FC<MenuBarProps> = ({
  className = 'bg-gray-200 text-black rounded-full',
  selectedClassName = 'bg-blue-500 text-white',
  onViewChange,
  activeView = 'manage',
  searchText,
  onSearchChange,
  isFiltered,
  resultCount,
  totalCount,
}) => {
  const [search, setSearch] = useState(searchText);

  return (
    <div className="flex items-center justify-between w-full">
      <div className='flex items-center gap-4 mr-2'>
        <Input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            onSearchChange(e.target.value);
          }}
          className="p-5 border-none bg-white rounded-full focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-none w-64 text-sm shadow-none"
        />
      </div>

      {/* Search Input */}
      <div className="flex items-center gap-3">
        <a href="/csv/template.csv" download="geo-mapper-template.csv" className='flex items-center gap-2 hover:opacity-65 bg-gray-201 rounded-full px-4 py-2'>
          <Download className='w-4 h-4' />
          Template
        </a>
      </div>
    </div>
  );
};

export default GeoMapperMenuBar;
